import type { ReactNode } from 'react'
import { H5, Text } from '@/components/atoms'

interface FeatureItemProps {
  icon: ReactNode
  title: string
  description: string
  className?: string
}

export function FeatureItem({
  icon,
  title,
  description,
  className = '',
}: FeatureItemProps) {
  return (
    <div className={`flex items-start gap-4 md:gap-6 ${className}`}>
      <div className="text-indigo-base flex size-fit shrink-0 items-center justify-center">
        {icon}
      </div>
      <div className="flex min-w-0 flex-1 flex-col justify-center gap-1">
        <H5 className="text-xl leading-6.5! text-neutral-900">{title}</H5>
        <Text className="text-neutral-900">{description}</Text>
      </div>
    </div>
  )
}
